import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ChevronRightFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.9957 22C17.4667 22 22 17.4734 22 12C22 6.52659 17.458 2 11.9869 2C6.5207 2 2 6.52659 2 12C2 17.4734 6.52941 22 11.9957 22ZM9.71632 17.015C9.44033 16.735 9.44512 16.3048 9.71151 16.047L13.9631 12.0087L9.71151 7.97913C9.43641 7.72136 9.44512 7.27849 9.725 7.0072C9.98661 6.76202 10.4001 6.78032 10.683 7.04203L14.989 11.126C15.5043 11.6067 15.5004 12.4233 14.989 12.8962L10.683 16.9841C10.4262 17.2284 9.95656 17.2419 9.71632 17.015Z"
        fill={color}
      />
    </svg>
  );
};

export { ChevronRightFilledSvg };
